export default "__VITE_ASSET__9f07f594__"